export const ADMIN_USERS = "ADMIN_USERS";
export const NORMAL_USERS = "NORMAL_USERS";
export const TABLE_DISPLAY_MODE_FEATURES = "FEATURES";
export const TABLE_DISPLAY_MODE_ACTIONS = "ACTIONS";
export const ADMIN_USERS_ITEMS_PER_PAGE = 5;

export const USER_STATE_CREATED = "Created"; // When record is created
export const USER_STATE_ACTIVE = "Active"; // Once email get verified
export const USER_STATE_INACTIVE = "InActive"; // Can be InActive when user left company



export const FEATURE_DYNAMIC_UI = "Dynamic UI";
export const FEATURE_BANNER = "Banner";
export const FEATURE_STORY = "Story";
export const FEATURE_NOTIFICATION = "Notification";
export const FEATURE_NOTIFICATION_REPORT = "Notification Report";
export const FEATURE_FOCUS_ITEM = "Focus Item";
export const FEATURE_REMOTE_CONFIG = "Remote Config";
export const FEATURE_PAYMENT_VERIFICATION = "Payment Verification";
export const FEATURE_CAMPAIGN_REPORT= "Campaign Report";
export const FEATURE_MANAGE_LOCATION= "Manage Location";
export const FEATURE_CART_REPORTING= "Cart Reporting";
export const FEATURE_WISHLIST_REPORTING= "Wishlist Reporting";
export const FEATURE_PRODUCT_FAQ= "Product Faq";
export const FEATURE_PREDICTION= "Prediction";
export const FEATURE_CAMPAIGN= "Campaign";
export const FEATURE_SHIFT= "Shift";
export const FEATURE_PRESCRIPTION= "Prescription";

export const FEATURE_MANAGE_USER= "Manage User";
export const FEATURE_ADD_FEATURE= "Add Feature";
export const FEATURE_BLOG= "Blog";

export const FEATURE_REWARD_CALCULATOR = "Reward Calculator";
export const FEATURE_REWARD_DASHBOARD = "Reward Transactions";
export const FEATURE_GENERATE_LINKS= "Generate Links";
export const FEATURE_FULFILLMENT_OPERATOR= "Fulfillment Operator";
